import styled from '@emotion/styled';
import React from 'react';
import { useFlagrZhixiaModulesValue } from 'hooks/business/system/useFlagr';

import giftPic from '../assets/gift.png';

export interface ZhixiaGiftProps {}

const ZhixiaGift = (props: ZhixiaGiftProps) => {
  const zhixiaModulesFlag = useFlagrZhixiaModulesValue();
  return zhixiaModulesFlag?.zhixiaGift ? (
    <Container>
      <img src={giftPic} alt="" />
      <span>
        凡注册ChatPlusAI的用户可领取 “知虾数据” 7 天试用会员；二、付费会员赠送 “知虾数据” 499
        元月度会员； <br />
        <strong>领取方式</strong>：请联系ChatPlusAI客服，了解活动详情。
      </span>
    </Container>
  ) : null;
};
export default React.memo(ZhixiaGift);

const Container = styled.div`
  background-color: #f6dcd6;
  width: 100%;
  height: 57px;
  display: flex;
  align-items: center;
  padding: 0 15px;
  margin-top: 16px;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 1.8em;
  > img {
    width: 35px;
    margin-right: 10px;
  }
  strong {
    color: #3e3e9b;
  }
`;
